import { TipoArredondamento } from './TipoArredondamento';

const opcoesArredondamento = [
  {
    valor: TipoArredondamento.CENTESIMAL,
    descricao: 'Arredondar para 2 casas decimais',
  },
  {
    valor: TipoArredondamento.DEZENA,
    descricao: 'Arredondar para a próxima dezena',
  },
  {
    valor: TipoArredondamento.CENTENA,
    descricao: 'Arredondar para a próxima centena',
  },
  {
    valor: TipoArredondamento.MILHAR,
    descricao: 'Arredondar para o próximo milhar',
  },
];

export default opcoesArredondamento;
